import { AddressInput } from '@api/generated/graphql';
import { valtioDevTools } from '@lib/utils/devTools';
import { UserE911AddressState } from '@modules/E911AddressModule/types';
import { proxy } from 'valtio';

/**
 * Defines the global state for the user e911 address
 */
export const userE911AddressState = proxy<UserE911AddressState>({
  e911Address: undefined,
});

valtioDevTools(userE911AddressState, 'userE911AddressState');

export const setUserE911AddressState = (e911Address: AddressInput | null) => {
  if (e911Address) {
    userE911AddressState.e911Address = e911Address;
  }
};
